'use client';

import { Image, Typography } from '@musinsa/mds';
import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from 'swiper/types';

import 'swiper/css';

function buildSnapImageSrc(imageUrl: string, width: number): string {
  return `${imageUrl}${imageUrl.includes('?') ? '&' : '?'}width=${width}&q=75&format=webp`;
}

interface SnapDetailImageBlockProps {
  imageUrls: string[];
  isMobile: boolean;
  snapId: string;
}

export const SnapDetailImageBlock = ({
  imageUrls,
  isMobile,
  snapId,
}: SnapDetailImageBlockProps) => {
  const width = isMobile ? 400 : 600;
  const srcList = imageUrls.map((url) => buildSnapImageSrc(url, width));

  const [currentIndex, setCurrentIndex] = useState(0);

  if (srcList.length === 0) {
    return null;
  }

  if (srcList.length === 1) {
    return (
      <div className="relative w-full" style={{ fontSize: 0 }}>
        <Image alt="" className="block w-full" height={4} src={srcList[0]} width={3} />
      </div>
    );
  }

  const handleSlideChange = (swiper: SwiperType) => {
    setCurrentIndex(swiper.activeIndex);
  };

  return (
    <div className="relative w-full" style={{ fontSize: 0 }}>
      <Swiper
        className="w-full"
        nested
        slidesPerView={1}
        spaceBetween={0}
        onSlideChange={handleSlideChange}
      >
        {srcList.map((src, index) => (
          <SwiperSlide key={`${snapId}-img-${index}`}>
            <Image alt="" className="block w-full" height={4} src={src} width={3} />
          </SwiperSlide>
        ))}
      </Swiper>
      <Typography
        variant="body13pxReg"
        className="pointer-events-none absolute right-[16px] bottom-[16px] z-[1]! flex h-[24px]! items-center justify-center rounded bg-[#000000]/[0.2] px-[7px]! text-white"
      >
        {currentIndex + 1} / {imageUrls.length}
      </Typography>
    </div>
  );
};
